import { useMemo } from "react";
import { StreamingHelper } from "@scrile/streaming-client/build";

export default function useWebRTC(options?: ConstructorParameters<typeof StreamingHelper>[0]) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => new StreamingHelper(options), []);
}
